'use strict';

import Turbolinks from 'turbolinks';

export default function(){
    Turbolinks.start();
}
